export const handleUnauthorized = (message: string, logout: any) => {
    if (message === "Unauthorized") {
        return logout();
    }
}
